// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"264":"blueprint","281":"plotlysystem","934":"plotly"}[chunkId] || chunkId) + "." + {"264":"60de9fbf","281":"4f9cc904","310":"b02ccf5a","523":"ce6be5a4","601":"66f11553","934":"80825510"}[chunkId] + ".chunk.js";
};